export default "../../src/img/lunivers_symbole_gradient.svg";